<router-outlet></router-outlet>
<app-toast-container></app-toast-container>
<div class="app-overlay" *ngIf="bootLoading">
  <div class="app-overlay__panel">
    <div class="button-spinner"></div>
    <span>{{ "loading" | translate }}</span>
  </div>
</div>
